import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';

function Footer() {
  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col lg={4} className="mb-4 mb-lg-0">
            <img 
              src={process.env.PUBLIC_URL + '/logo.png'} 
              alt="6G AI Sweden AB" 
              height="50"
              style={{ objectFit: 'contain', marginBottom: '1rem' }}
              loading="lazy"
            />
            <p className="footer-text">
              Your AI Factory in Sweden. World-class AI cloud infrastructure powered by NVIDIA, sovereign and sustainable.
            </p>
          </Col>
          <Col lg={2} md={4} sm={6} className="mb-4 mb-md-0">
            <h5 className="footer-title">Services</h5>
            <ul className="footer-links">
              <li><Link to="/services">GPU Rental</Link></li>
              <li><Link to="/services">Use Case Dev</Link></li>
              <li><Link to="/services">AI Solutions</Link></li>
              <li><Link to="/services">Advisory</Link></li>
            </ul>
          </Col>
          <Col lg={2} md={4} sm={6} className="mb-4 mb-md-0">
            <h5 className="footer-title">Company</h5>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/infrastructure">Infrastructure</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </Col>
          <Col lg={2} md={4} sm={6}>
            <h5 className="footer-title">Legal</h5>
            <ul className="footer-links">
              <li><a href="mailto:info@6gai.se?subject=Privacy Policy">Privacy Policy</a></li>
              <li><a href="mailto:info@6gai.se?subject=Terms of Service">Terms of Service</a></li>
              <li><a href="mailto:info@6gai.se?subject=Cookie Policy">Cookie Policy</a></li>
            </ul>
          </Col>
          <Col lg={2} md={4} sm={6}>
            <h5 className="footer-title">Connect</h5>
            <ul className="footer-links">
              <li><a href="https://www.linkedin.com/company/6g-digital-sweden-ab/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
              <li><a href="https://x.com/6gaisweden" target="_blank" rel="noopener noreferrer">X (Twitter)</a></li>
              <li><a href="mailto:info@6gai.se">info@6gai.se</a></li>
            </ul>
          </Col>
        </Row>
        <div className="footer-bottom">
          <p>&copy; 2026 6G AI Sweden AB. All rights reserved.</p>
          <p>Stockholm, Sweden</p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
